import { c as _c } from "react/compiler-runtime";
import ViverseButton from '@/components/ViverseButton';
import { SEARCH_PARAM_KEYS } from '@/constants/search';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { Link } from '@/i18n/navigation';
import { getHiddenWorldTags } from '@/lib/configs';
type GenreTagLinkProps = {
  href: string;
  label: string;
};
function GenreTagLink(t0) {
  const $ = _c(5);
  const {
    href,
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <ViverseButton variant="filter" className="caption text-vive-primary-20 min-w-fit rounded-[5px] bg-white/10 px-3 py-0.5 text-[12px] backdrop-blur-[50px]">{label}</ViverseButton>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== href || $[3] !== t1) {
    t2 = <Link href={href}>{t1}</Link>;
    $[2] = href;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function WorldGenres() {
  const $ = _c(13);
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== roomData.content_type?.code || $[1] !== roomData.custom_tags || $[2] !== roomData.tags) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const hiddenWorldTags = getHiddenWorldTags();
      const genres = (roomData.tags || []).filter(tag => !hiddenWorldTags.includes(tag.name));
      const customTags = (roomData.custom_tags || []).filter(tag_0 => !genres.some(g => g.name === tag_0));
      const contentTypeCode = roomData.content_type?.code;
      if (genres.length === 0 && customTags.length === 0) {
        t3 = null;
        break bb0;
      }
      t0 = "flex w-full flex-wrap gap-2";
      t1 = genres.map(_temp);
      let t4;
      if ($[7] !== contentTypeCode) {
        t4 = tag_2 => {
          const params = new URLSearchParams({
            [SEARCH_PARAM_KEYS.KEYWORD]: tag_2
          });
          if (contentTypeCode) {
            params.set(SEARCH_PARAM_KEYS.TAB, contentTypeCode);
          }
          return <GenreTagLink href={`/search?${params.toString()}`} key={tag_2} label={tag_2} />;
        };
        $[7] = contentTypeCode;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      t2 = customTags.map(t4);
    }
    $[0] = roomData.content_type?.code;
    $[1] = roomData.custom_tags;
    $[2] = roomData.tags;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t4 = <div className={t0}>{t1}{t2}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(tag_1) {
  return <GenreTagLink href={`/genre/${tag_1.name}`} key={tag_1.id} label={tag_1.name} />;
}
export default WorldGenres;